"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
require("antd/lib/select/style/css");
var select_1 = __importDefault(require("antd/lib/select"));
require("antd/lib/form/style/css");
var form_1 = __importDefault(require("antd/lib/form"));
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var HTMLEditor_1 = __importDefault(require("../editor/HTMLEditor"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var SettingsForm = /*#__PURE__*/ react_1.default.memo(function (_ref) {
    var _initialValues$privac;
    var onFinish = _ref.onFinish, loading = _ref.loading, initialValues = _ref.initialValues;
    var _Form$useForm = form_1.default.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    var ppQuillRef = (0, react_1.useRef)(undefined);
    var modals = (0, hooks_1.useAppSelector)(function (state) {
        return state.modals.items;
    });
    var modalOptions = (0, react_1.useMemo)(function () {
        return modals.map(function (m) {
            return {
                value: m.id,
                label: m.title
            };
        });
    }, [modals]);
    var _onFinish = (0, react_1.useCallback)(function (values) {
        var _values$terms_modal;
        return (onFinish !== null && onFinish !== void 0 ? onFinish : function () { })({
            terms_modal: (_values$terms_modal = values.terms_modal) !== null && _values$terms_modal !== void 0 ? _values$terms_modal : null,
            privacy_policy: ppQuillRef.current.getEditor().root.innerHTML
        });
    }, []);
    return (0, jsx_runtime_1.jsxs)(form_1.default, {
        form: form,
        layout: "vertical",
        initialValues: initialValues,
        onFinish: _onFinish,
        children: [(0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: "terms_modal",
                label: "Terms Modal",
                help: "Shows on the first run of the app. Can be used to present terms and conditions, an " + "introduction to the app, etc.",
                children: (0, jsx_runtime_1.jsx)(select_1.default, {
                    options: modalOptions
                })
            }), (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: "privacy_policy",
                label: "Privacy Policy",
                help: "Shows on the Privacy Policy screen of the app.",
                children: (0, jsx_runtime_1.jsx)(HTMLEditor_1.default, {
                    initialValue: (_initialValues$privac = initialValues === null || initialValues === void 0 ? void 0 : initialValues.privacy_policy) !== null && _initialValues$privac !== void 0 ? _initialValues$privac : "",
                    innerRef: ppQuillRef
                })
            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                type: "primary",
                htmlType: "submit",
                loading: loading,
                children: "Save"
            })]
    });
});
exports.default = SettingsForm;
